import axios from 'axios'
import { getTimeZone, getClientID, debrisMap, createSavedCartDates } from '@/utilities.js'

export default {
  namespaced: true,
  state: () => ({
    lockRateName: '',
    lockRateEmail: '',
    isLockRateInProgress: false,
    isLockRateModalOpen: false,
    isLockRateConfirmationModalOpen: false,
    productToLockRate: {},
    showError: false
  }),
  actions: {
    sendEmail ({ state, rootState, commit }, { expiresDate, uuid }) {
      const { price, rentalPeriod, size, tonnage, taxAmount } = state.productToLockRate
      const { selectedDebrisType } = rootState.project
      const { postalCode } = rootState.customer.serviceAddress
      const template = process.env.VUE_APP_BRAND === 'BD' ? 'ECOM_BD_CART' : 'ECOM_DC_CART'
      const brand = process.env.VUE_APP_BRAND
      const debrisType1 = debrisMap[selectedDebrisType[0]] || ''
      const debrisType2 = debrisMap[selectedDebrisType[1]] || ''

      // production and staging use https
      // TODO: Clean this up and use ENV and Brand variables
      let returnUrl = ''
      if (location.host.includes('localhost')) {
        returnUrl = `http://${location.host}/cart/?uuid=${uuid}`
      } else {
        returnUrl = `https://${location.host}/cart/?uuid=${uuid}`
      }

      const templateObj = `
        { mergeData:
          [
            {name:"TITLE:FNAME",content:"${state.lockRateName}"},
            {name:"serviceZip",content:"${postalCode}"},
            {name:"expiresOn",content:"${expiresDate.toDateString()}"},
            {name:"size",content:"${size}"},
            {name:"debrisType1",content:"${debrisType1}"},
            {name:"debrisType2",content:"${debrisType2}"},
            {name:"price",content:"${Number(price) + Number(taxAmount)}"},
            {name:"tonnage",content:"${tonnage}"},
            {name:"rentalPeriod",content:"${rentalPeriod}"},
            {name:"orderLink",content:"${returnUrl}"},
            {name:"taxAmount",content:"${taxAmount}"}
          ]
        }`
      // TODO: replace this with hubRequest from utilities.js
      return axios.post(`${process.env.VUE_APP_SERVER}/api/sendemail`,
        {
          sendTo: state.lockRateEmail,
          sendToName: state.lockRateName,
          subject: 'Saved Cart',
          templateObj,
          template,
          brand
        })
        .then(res => {
          commit('closeLockRateModal')
          commit('isLockRateInProgress', false)
          commit('toggleLockRateConfirmationModal', true)
        })
        .catch(e => {
          state.showError = true
        })
    },
    executeLockRate ({ state, commit, dispatch, rootState }) {
      const onPoint = rootState.onPoint
      const { fname, lname, phoneNumber, email, deliveryDate, billingSameAsDelivery } = rootState.customer
      const { selectedProjectType, selectedDebrisType, selectedFillType } = rootState.project
      const savedCart = JSON.stringify(rootState.cart)
      const makoResponse = JSON.stringify(rootState.dumpster.makoResponse)
      const delivery = {
        serviceAddress: rootState.customer.serviceAddress,
        deliveryDate,
        placementInstructions: rootState.customer.placementInstructions
      }
      const contact = {
        fname,
        lname,
        phoneNumber,
        email
      }
      const project = {
        selectedProjectType,
        selectedDebrisType,
        selectedFillType
      }

      const timezone = getTimeZone(new Date())
      const { createdDate, expiresDate } = createSavedCartDates()
      // insert saved cart into database
      // TODO: replace this with hubRequest from utilities.js
      return axios.post(`${process.env.VUE_APP_SERVER}/api/savedCart`, {
        host: location.host,
        billingSameAsDelivery,
        createdDate: createdDate.toUTCString(),
        expiresDate: expiresDate.toUTCString(),
        timezone,
        lockRateEmail: state.lockRateEmail,
        phoneNumber: state.phoneNumber,
        project,
        name: state.lockRateName,
        clientId: getClientID(),
        makoResponse,
        savedCart,
        delivery,
        contact,
        onPoint
      })
        .then(({ data }) => {
          return dispatch('sendEmail', {
            expiresDate,
            uuid: data.uuid
          })
        })
        .catch(e => {
          console.log(e)
          state.showError = true
        })
    }
  },
  mutations: {
    lockInRate (state, product) {
      state.showError = false
      state.productToLockRate = product
      state.isLockRateModalOpen = true
    },
    closeLockRateModal (state) {
      state.isLockRateModalOpen = false
    },
    toggleLockRateConfirmationModal (state, val) {
      state.isLockRateConfirmationModalOpen = val
    },
    isLockRateInProgress (state, val) {
      state.isLockRateInProgress = val
    },
    lockRateEmail (state, val) {
      state.lockRateEmail = val
    },
    lockRateName (state, val) {
      state.lockRateName = val
    }
  }
}
